import { createSlice } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { TenantState } from './types'

const initialState: TenantState = {
  openCreateTenantMenu: false,
  openCreateManagerMenu: false,
  openCreateNoteMenu: false,
}

export const tenantSlice = createSlice({
  name: 'tenantSlice',
  initialState,
  reducers: {
    openCreateTenantMenu(state, action) {
      state.openCreateTenantMenu = action.payload
    },
    openCreateManagerMenu(state, action) {
      state.openCreateManagerMenu = action.payload
    },
    setAccessedTenant(state, action) {
      state.tenant = action.payload
    },
    openCreateNoteMenu(state, action) {
      state.openCreateNoteMenu = action.payload
    },
  },
})

export const tenantReducer = persistReducer(
  {
    key: 'rtk:tenant',
    storage,
    whitelist: [''],
  },
  tenantSlice.reducer,
)
